export const ABSENCE_UNEXCUSED_STATUSES = [
  'unexcused',
  'pending',
  'guardian_review'
] as const

const ABSENCE_STATUS_TYPES = [
  ...ABSENCE_UNEXCUSED_STATUSES,
  'excused',
  'approved',
  'rejected'
] as const

export type ClassUnexcusedAbsenceStatus =
  (typeof ABSENCE_UNEXCUSED_STATUSES)[number]

export type ClassAbsenceStatus = (typeof ABSENCE_STATUS_TYPES)[number]
